import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { getBrandByNetwork } from '../../../store/actions';

import { useHistory } from 'react-router';

const useGetUrlParams = (args: any) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const brand = useSelector((state: any) => state.brand);
    const { name } = args;
    const search = window.location.search;
    const params = new URLSearchParams(search);
    let result: any = params.get(name);
    result = isNaN(Number(result == null ? undefined : result)) ? undefined : Number(result);

    useEffect(() => {
        const logged = localStorage.getItem('authUser');
        const authUser = logged ? JSON.parse(logged) : {};
        const exist = Object.keys(authUser).length;
        if (!result && search !== '') if (!logged) history.push('/login?' + name + '=36451');
        if (exist == 0) {
            dispatch(getBrandByNetwork({ networkId: result }));
        } else {
            const currentUrl = window.location.href;
            if (currentUrl == 'http://localhost:3000/demo' || currentUrl == 'https://innobofront.azurewebsites.net/demo') {
                dispatch(getBrandByNetwork({ networkId: '37370' }));
            }
        }
    }, [result]);

    const [state, setState] = useState<any>({
        url: '',
        brand: {},
        networkId: result,
    });

    useEffect(() => {
        setState({
            ...state,
            brand,
            result: result,
            url: result ? '?' + name + '=' + result : '',
        });
    }, [brand, result]);

    return state;
};

export default useGetUrlParams;
